import { Api } from '@/services/Api'

export default {

  fetchInverterStatus(plantIds) {
    return Api().post(
      '/api/v2/inverter-status/status',
      { plantIds }
    )
  },

  fetchPlantTree(plantIds) {
    return Api().post(
      '/api/v2/inverter-status/plantTree',
      { plantIds }
    )
  }

}